import React from 'react';
import Map from 'react-map-gl';
import { useMapContext } from './MapContext';

// const MapDisplay = ({ mapRef, handleMapClick, children }) => {
const MapDisplay = ({ children }) => {
    const {mapRef, handleMapClick, } = useMapContext();

    return (
        <Map
            ref={mapRef}
            mapboxAccessToken="pk.eyJ1IjoibGVicmFuay11bSIsImEiOiJjbG82Ymxxd2wwaW16Mm1sbW1zZDNibm9mIn0.ioLjzOX9ELIsHmfp1JW42w"
            initialViewState={{
                longitude: -83.1,
                latitude: 42.35,
                zoom: 10.8,
                pitch: 45,
            }}
            style={{ width: '100%', height: '100%' }}
            mapStyle="mapbox://styles/mapbox/dark-v11"
            onClick={(event) => handleMapClick(event)} // Call handleMapClick on map click
        >
            {children}
        </Map>
    );
};

export default MapDisplay;
